import { FC } from 'react';
import Logo from '@lemon8/web-app-shared/logo/square_fullcolor.png';
import Slogan from '~/assets/slogan_google/en.png';
import { useAtomValue } from 'jotai';
import { $HomepageMaterial } from 'shared/atoms/homepage-material';
import { SharingCardMeta } from './sharing-card';

export const HomepageHead: FC = () => {
  const { posterUrl } = useAtomValue($HomepageMaterial);

  return (
    <>
      {posterUrl && <link rel="preload" as="image" href={posterUrl} />}
      <SharingCardMeta />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            url: 'https://www.lemon8-app.com',
            logo: Logo,
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            url: 'https://www.lemon8-app.com',
            logo: Logo,
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ImageObject',
            contentUrl: Slogan,
            creditText: 'Lemon8',
            creator: {
              '@type': 'Organization',
              name: 'Lemon8',
            },
            copyrightNotice: '©2024 Heliophilia Pte. Ltd. All Rights Reserved.',
          }),
        }}
      />
    </>
  );
};
